import { generateFeatureFlagUser } from '@/utils/generateFeatureFlagUser';

import { InitialBridgeContext, IInteropBridge, ClientType } from './types';

export class IosBridgeImpl implements IInteropBridge {
  public clientType: ClientType = ClientType.iOS;

  public async getInitialBridgeContext(): Promise<InitialBridgeContext> {
    try {
      const bridgeContext = JSON.parse(
        await window.webkit.messageHandlers.getInitialBridgeContextJson.postMessage({})
      );

      return Promise.resolve({
        ...bridgeContext,
        featureFlagUser: bridgeContext.featureFlagUser ?? generateFeatureFlagUser(),
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }

  public launchAccountPage(): void {
    window.webkit.messageHandlers.launchAccountPage.postMessage({}).catch(() => {});
  }

  public launchEComm(path: string): void {
    window.webkit.messageHandlers.launchEComm.postMessage(path).catch(() => {});
  }

  public launchExternalWeb(url: string): void {
    window.webkit.messageHandlers.launchExternalWeb.postMessage(url).catch(() => {});
  }

  public launchNativeSignIn(): void {
    window.webkit.messageHandlers.launchNativeSignIn.postMessage({}).catch(() => {});
  }

  public launchNativeSignUp(): void {
    window.webkit.messageHandlers.launchNativeSignUp.postMessage({}).catch(() => {});
  }

  public launchPhoneCall(tel: string): void {
    window.webkit.messageHandlers.launchPhoneCall.postMessage(tel).catch(() => {});
  }

  public launchLeaveFeedback(): void {
    window.webkit.messageHandlers.launchLeaveFeedback.postMessage({}).catch(() => {});
  }

  public launchNativeMyPurchasesModal(): void {
    window.webkit.messageHandlers.launchNativeMyPurchasesModal.postMessage({}).catch(() => {});
  }

  public launchNativeMyPassAndBenefitsModal(): void {
    window.webkit.messageHandlers.launchNativeMyPassAndBenefitsModal
      .postMessage({})
      .catch(() => {});
  }

  public launchBilling(): void {
    window.webkit.messageHandlers.launchBilling.postMessage({}).catch(() => {});
  }
}
